<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Dashboard">
          <!-- AS PIC-->
          <b-row>
            <div class="d-inline col-md-10">
              <h3>My Actionable Tickets</h3>
              As PIC
              <div class="float-right">
                <span class="badge badge-dark">Daily Reports</span>
              </div>
            </div>
          </b-row>
          <b-row>
            <b-col sm="6" md="2"  class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  2
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">OPEN</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2"  class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  13
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">Solved</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  2
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">ON HOLD</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  6
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">OVERDUE</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  11
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">DUE TODAY</small>
              </b-card>
            </b-col>
          </b-row>
          <!-- AS Requester-->
          <b-row>
            <b-col sm="12" md="10">
              <div class="d-inline">
                As Requester
              </div>
              <div class="float-right">
                <span class="badge badge-dark">+ NEW</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  0
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">OPEN</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  3
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">Solved</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  8
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">ON HOLD</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  1
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">OVERDUE</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  12
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">DUE TODAY</small>
              </b-card>
            </b-col>
          </b-row>
          <!--Group Ticket-->
          <br>
          <br>
          <h3>Group Tickets</h3>
          <b-row>
            <b-col sm="12" md="10">
              <div class="d-inline">
                Application And Content
              </div>
              <div class="float-right">
                <span class="badge badge-dark">+ Reports</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  0
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">OPEN</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  6
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">ON hold</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  2
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">Overdue</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  15
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">due today</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  3
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">unassigned</small>
              </b-card>
            </b-col>
          </b-row>
          <!--Other Tickets-->
          <br>
          <br>
          <h3>Other Tickets</h3>
          <b-row>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  0
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">CC - ed</small>
              </b-card>
            </b-col>
            <b-col sm="6" md="2" class="text-center">
              <b-card style="border-radius: 20px" class="shadow bg-white">
                <div class="h1 text-muted">
                  2
                </div>
                <small class="text-muted text-uppercase text-center font-weight-bold">Unassigned</small>
              </b-card>
            </b-col>
          </b-row>

          <!--Daily Reports-->
          <tinymce id="d1" v-model="data"
                   :toolbar1="configToolbar1"
                   :other_options="options"></tinymce>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getService} from '../services'
  import tinymce from 'vue-tinymce-editor'


  export default {
    components: {
      tinymce
    },
    data() {
      return {
        descriptionLong: '',
        employee: [],
        data:'',
        configToolbar1 : 'undo redo | fontselect | forecolor | bold italic | outdent indent | link | code',
        options : {
          menubar: false,
          statusbar: false
        }
      }
    },
    created: function () {
      // this.getDataEmployee();
      // if (this.$store.getters.check == true) {
      //   this.getDataEmployee();
      // } else {
        // var interval = setInterval(() => {
        //   if (this.$store.getters.check == true) {
        //     clearInterval(interval);
        //     // console.log(this.$store.getters.data);
        //   }
        // }, 1000)
      },
    methods: {
      getDataEmployee: function () {
        getService.profile()
          .then(
            employee => {
              this.employee = employee
            }
          )
      }
    }
  }
</script>
